<div
  class="chart-toolbar-container flex flex-wrap items-center justify-between gap-4"
>
  <div class="flex flex-1 items-center gap-4">
    @if (showHistorySelector) {
      <pr-charting-history-selector
        [chartHistory]="chartHistory$ | async"
        [selected]="chart$ | async"
        (selectedChange)="selectChart($event)"
      />
    }

    <mat-form-field floatLabel="always" subscriptSizing="dynamic">
      <mat-select
        canSelectNullableOptions
        [formControl]="treatmentPlanCtrl"
        [compareWith]="compareWithFn"
      >
        <mat-option [value]="undefined">All Treatment Plans</mat-option>
        @for (plan of treatmentPlans$ | async; track plan.ref.path) {
          <mat-option [value]="plan">{{ plan.name }}</mat-option>
        }
      </mat-select>
      <mat-label>Select Treatment Plan</mat-label>
    </mat-form-field>

    <ng-content select="[compareWithChart]" />
  </div>

  <div class="flex items-center gap-4">
    <pr-chart-view-selector
      [view]="view$ | async"
      (selectionChange)="selectView($event)"
    />
    <pr-chart-section-selector
      [section]="section$ | async"
      (selectionChange)="selectSection($event)"
    />
    <ng-content />
    <ng-content select="[perioSettings]" />
  </div>
</div>
